

































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";

import { bus } from "@/pages/transitweb/main";

import { FiltersState } from "@/store/filters/types";
import { DatasetState, DensityType } from "@/store/datasets/types";
import { AssistantState } from "@/store/assistant/types";

import TransitFilter from "@/components/filters/Filter.vue";

import { isNullOrUndefined } from "util";

@Component({
    components: {
        TransitFilter,
    },
})
export default class Filters extends Vue {
    @Prop() private getMap!: any;

    @Getter("auth/isAllowedSensitiveInfo") isAllowedSensitiveInfo!: boolean;
    @Getter("auth/isAdmin") isAdmin?: boolean;
    @Getter("auth/isConstrained") isConstrained: any; // Returns an anonymous function
    @Getter("auth/constrainedValues") constrainedValues: any; // Returns an anonymous function

    @State("filters") filters!: FiltersState;
    @Action("filters/removeUnusedFilters") removeUnusedFilters: any;
    @Action("filters/setFilterValue") setFilterValue: any;
    @Action("filters/setFilterParams") setFilterParams: any;
    @Action("filters/setFilterEnabled") setFilterEnabled: any;
    @Action("filters/setFiltersDirty") setFiltersDirty: any;
    @Getter("filters/filtersWithValues") filtersWithValues!: string[];
    @Getter("filters/isDirty") isFiltersDirty!: boolean;
    @Getter("filters/isFiltered") isFiltered!: boolean;
    @Getter("filters/disabled") isDisabled!: boolean;
    @Getter("filters/visible") isVisible!: boolean;
    @Getter("filters/isSpatialFilter") isSpatialFilter: any; // Returns an anonymous function
    @Getter("filters/filterWorksWith") filterWorksWith: any; // Returns an anonymous function
    @Getter("filters/filterHasValue") filterHasValue: any; // Returns an anonymous function
    @Getter("filters/filterUrl") filterUrl: any; // Returns an anonymous function
    @Getter("filters/hasUnconstrainedFilters")
    hasUnconstrainedFilters!: boolean;

    @State("assistant") assistant!: AssistantState;

    @State("datasets") datasets!: DatasetState;

    //@Watch('densityType')
    //onDensityTypeChanged(val: DensityType, oldVal: DensityType) {
    //    if (this.densityType === DensityType.Rail || this.densityType === DensityType.Road) {

    //        // Need to update commodity filter here with relevant query params - so the selection list updates when the density type is switched to Road or Rail.
    //        // At the moment, if Events is selected, commodity lists are updated using report_type parameter, it'd be better to replace it with density type.
    //        // It would be nicer to do all filters using density type and via store...
    //        this.setFilterParams({ filter: 'commodity', params: { density_type: this.densityType, } });
    //        this.refreshMap;
    //    }
    //}

    get densityType(): DensityType {
        return this.datasets.type;
    }

    created() {
        // Need to update commodity filter here with relevant query params - so the selection list updates.
        // this.setFilterParams({ filter: 'commodity', params: { density_type: this.densityType, } });

        bus.$on("append_name_filter", (filterId: string, value: any) => {
            let filter = this.$refs[filterId + "_filter"] as any;
            var options = (filter[0] as TransitFilter).options;
            var res = options.filter(function (option: any) {
                return option.code == value;
            });
            if (res.length > 0) {
                this.setFilterEnabled({ filter: filterId, value: true });
                let filter_values = (filter[0] as TransitFilter).value;
                if (isNullOrUndefined(filter_values)) {
                    filter_values = value;
                } else {
                    if (!filter_values.includes(value[0])) {
                        let values_copy = [...filter_values];
                        values_copy.push(value[0]);
                        filter_values = values_copy;
                    }
                }
                (filter[0] as TransitFilter).value = filter_values;
            } else {
                alert(
                    "The filter selected is not an available option: " + value,
                ); // 'add_special_filter'
            }
        });

        bus.$on(
            "add_special_filter",
            (filterId: string, value: any, setAsOptions?: boolean) => {
                let filter = this.$refs[filterId + "_filter"] as any;

                if (setAsOptions) {
                    (filter[0] as TransitFilter).options = [
                        { code: value[0], name: value[0] },
                    ];
                }
                (filter[0] as TransitFilter).value = value;
            },
        );
    }

    destroyed() {
        bus.$off("append_name_filter");
        bus.$off("add_special_filter");
    }

    filter_assistant() {
        /*
         * Only create an assistant question when at least one filter
         * currently has a selected value.
         */
        if (this.isFiltered) {
            var queryParams: any = {};

            /*
             * Convert each selected filter value from its internal code
             * into the corresponding user-facing label.
             */
            for (var filter in this.filtersWithValues) {
                filter = this.filtersWithValues[filter];

                var filter_obj = (this.$refs[filter + "_filter"] as any)[0];
                var options = filter_obj.options;

                /*
                 * Find the option labels matching the selected filter codes.
                 */
                var labels = options
                    .filter(function (option: any) {
                        return filter_obj.value.includes(option.code);
                    })
                    .map(function (option: any) {
                        return option.name;
                    });

                /*
                 * Remove duplicate labels and replace underscores so that
                 * the values read naturally in the assistant question.
                 */
                var unique_labels = labels
                    .filter((element: any, index: number) => {
                        return labels.indexOf(element) === index;
                    })
                    .map(function (item: string) {
                        return item.replace(/_/g, " ");
                    });

                queryParams[filter + "_filter"] = unique_labels;
            }

            /*
             * Include the currently selected transport mode even though it
             * is not handled as a standard filter component.
             */
            queryParams["mode_filter"] = this.densityType.toLowerCase();

            /*
             * Build the natural-language question and send it to the
             * assistant through the application event bus.
             */
            var question = this.create_filter_question(queryParams);

            bus.$emit("assistant", {
                content: question,
            });
        }
    }

    create_filter_question(values_q: any) {
        // console.log(values_q);

        /*
         * Normalise the transport mode so comparisons are not affected
         * by capitalisation.
         */
        const mode = values_q["mode_filter"]?.toLowerCase();

        /*
         * Air and sea use country and subregion filters to describe
         * international origins and destinations.
         */
        const isInternationalMode = mode === "air" || mode === "sea";

        /*
         * Read and normalise the selected direction.
         *
         * direction_filter is normally supplied as an array because it is
         * produced by the standard filter processing in filter_assistant().
         */
        const directionValues: string[] = values_q["direction_filter"] || [];

        const direction =
            directionValues.length > 0
                ? directionValues[0].toLowerCase()
                : undefined;

        const isImports = direction === "imports";
        const isExports = direction === "exports";
        const isDomestic = direction === "domestic";

        /*
         * Commodity filters
         */
        var commodities: string[] = [];

        if ("commodity_filter" in values_q) {
            commodities = commodities.concat(values_q["commodity_filter"]);
        }

        if ("commod_l2_filter" in values_q) {
            commodities = commodities.concat(values_q["commod_l2_filter"]);
        }

        if ("commod_l3_filter" in values_q) {
            commodities = commodities.concat(values_q["commod_l3_filter"]);
        }

        /*
         * Link and transport route filters
         */
        var link_name: string[] = [];

        if ("roadname_filter" in values_q) {
            link_name = link_name.concat(values_q["roadname_filter"]);
        }

        if ("railname_filter" in values_q) {
            link_name = link_name.concat(values_q["railname_filter"]);
        }

        if ("seachannel_filter" in values_q) {
            link_name = link_name.concat(values_q["seachannel_filter"]);
        }

        /*
         * When no specific road, rail line or sea channel is selected,
         * use the transport mode as the route description.
         */
        if (link_name.length === 0 && mode) {
            link_name = [mode];
        }

        /*
         * Origin enterprise filters.
         *
         * These are generally used for road and rail movements.
         */
        var originEnterprises: string[] = [];

        if ("origenterprise_filter" in values_q) {
            originEnterprises = originEnterprises.concat(
                values_q["origenterprise_filter"],
            );
        }

        if ("origenterprisecategory_filter" in values_q) {
            originEnterprises = originEnterprises.concat(
                values_q["origenterprisecategory_filter"],
            );
        }

        /*
         * Origin geographic filters.
         *
         * These are generally used for air and sea movements.
         */
        var originLocations: string[] = [];

        if ("origcountry_filter" in values_q) {
            originLocations = originLocations.concat(
                values_q["origcountry_filter"],
            );
        }

        if ("origsubregion_filter" in values_q) {
            originLocations = originLocations.concat(
                values_q["origsubregion_filter"],
            );
        }

        /*
         * Destination enterprise filters.
         *
         * These are generally used for road and rail movements.
         */
        var destinationEnterprises: string[] = [];

        if ("destenterprise_filter" in values_q) {
            destinationEnterprises = destinationEnterprises.concat(
                values_q["destenterprise_filter"],
            );
        }

        if ("destenterprisecategory_filter" in values_q) {
            destinationEnterprises = destinationEnterprises.concat(
                values_q["destenterprisecategory_filter"],
            );
        }

        /*
         * Destination geographic filters.
         *
         * These are generally used for air and sea movements.
         */
        var destinationLocations: string[] = [];

        if ("destcountry_filter" in values_q) {
            destinationLocations = destinationLocations.concat(
                values_q["destcountry_filter"],
            );
        }

        if ("destsubregion_filter" in values_q) {
            destinationLocations = destinationLocations.concat(
                values_q["destsubregion_filter"],
            );
        }

        /*
         * Record whether the user explicitly selected an origin or destination
         * before applying any direction-based Australian defaults.
         */
        const hasSelectedOrigin =
            originEnterprises.length > 0 || originLocations.length > 0;

        const hasSelectedDestination =
            destinationEnterprises.length > 0 ||
            destinationLocations.length > 0;

        /*
         * When no direction, origin or destination is selected for air or sea,
         * the question should cover both Australian imports and exports.
         */
        const includeImportsAndExports =
            isInternationalMode &&
            !direction &&
            !hasSelectedOrigin &&
            !hasSelectedDestination;

        /*
         * Apply direction-based defaults for air and sea.
         *
         * Imports:
         *     Australia is the destination.
         *
         * Exports:
         *     Australia is the origin.
         *
         * Domestic:
         *     The movement takes place within Australia.
         */
        if (isInternationalMode) {
            if (isImports && !hasSelectedDestination) {
                destinationLocations = ["Australia"];
            }

            if (isExports && !hasSelectedOrigin) {
                originLocations = ["Australia"];
            }

            if (isDomestic) {
                if (!hasSelectedOrigin) {
                    originLocations = ["Australia"];
                }

                if (!hasSelectedDestination) {
                    destinationLocations = ["Australia"];
                }
            }
        }

        /*
         * When a specific international direction has not been selected,
         * but only one side of the movement has been filtered, default
         * the other side to Australia.
         *
         * Destination Argentina only:
         *     departing from Australia and arriving in Argentina
         *
         * Origin Argentina only:
         *     departing from Argentina and arriving in Australia
         */
        if (isInternationalMode && !direction && !includeImportsAndExports) {
            if (!hasSelectedOrigin && hasSelectedDestination) {
                originLocations = ["Australia"];
            }

            if (hasSelectedOrigin && !hasSelectedDestination) {
                destinationLocations = ["Australia"];
            }
        }

        /*
         * Australian boundary filters.
         *
         * These are generally used for road and rail movements.
         */
        var boundary: string[] = [];

        if ("boundary1_filter" in values_q) {
            boundary = boundary.concat(values_q["boundary1_filter"]);
        }

        if ("boundary2_filter" in values_q) {
            boundary = boundary.concat(values_q["boundary2_filter"]);
        }

        if ("boundary3_filter" in values_q) {
            boundary = boundary.concat(values_q["boundary3_filter"]);
        }

        if ("boundary4_filter" in values_q) {
            boundary = boundary.concat(values_q["boundary4_filter"]);
        }

        if ("boundary5_filter" in values_q) {
            boundary = boundary.concat(values_q["boundary5_filter"]);
        }

        if ("boundary6_filter" in values_q) {
            boundary = boundary.concat(values_q["boundary6_filter"]);
        }

        if ("boundary7_filter" in values_q) {
            boundary = boundary.concat(values_q["boundary7_filter"]);
        }

        /*
         * Road and rail movements default to Australia when no
         * Australian boundary has been selected.
         *
         * Air and sea movements do not use this boundary wording because
         * their origin and destination country filters describe the geography.
         */
        if (boundary.length === 0 && !isInternationalMode) {
            boundary = ["Australia"];
        }

        /*
         * Build the question for the assistant.
         */
        var question = "Please tell me about the supply chain movements";

        if (commodities.length > 0) {
            question += " of " + commodities.join(", ");
        }

        /*
         * When no international direction, origin or destination has been
         * selected, explicitly request both imports and exports.
         */
        if (includeImportsAndExports) {
            question += " imported to and exported from Australia";
        } else if (
            isInternationalMode &&
            isImports &&
            !hasSelectedOrigin &&
            !hasSelectedDestination
        ) {
            /*
             * When Imports is selected without geographic filters, use a
             * concise direction-based description.
             */
            question += " imported into Australia";
        } else if (
            isInternationalMode &&
            isExports &&
            !hasSelectedOrigin &&
            !hasSelectedDestination
        ) {
            /*
             * When Exports is selected without geographic filters, use a
             * concise direction-based description.
             */
            question += " exported from Australia";
        } else if (
            isInternationalMode &&
            isDomestic &&
            !hasSelectedOrigin &&
            !hasSelectedDestination
        ) {
            /*
             * When Domestic is selected without geographic filters, describe
             * the movements as occurring within Australia rather than saying
             * they depart from and arrive in Australia.
             */
            question += " within Australia";
        } else {
            /*
             * Add origins.
             */
            if (originEnterprises.length > 0) {
                question += " departing from " + originEnterprises.join(", ");
            }

            if (originLocations.length > 0) {
                question += " departing from " + originLocations.join(", ");
            }

            /*
             * Recalculate the origin and destination flags after applying
             * the direction-based Australian defaults.
             */
            const hasOrigin =
                originEnterprises.length > 0 || originLocations.length > 0;

            const hasDestination =
                destinationEnterprises.length > 0 ||
                destinationLocations.length > 0;

            /*
             * Join the origin and destination clauses with "and" when
             * both sides are present.
             */
            if (hasOrigin && hasDestination) {
                question += " and";
            }

            /*
             * Use "arriving at" for enterprises and facilities.
             */
            if (destinationEnterprises.length > 0) {
                question += " arriving at " + destinationEnterprises.join(", ");
            }

            /*
             * Use "arriving in" for countries and subregions.
             */
            if (destinationLocations.length > 0) {
                question += " arriving in " + destinationLocations.join(", ");
            }
        }

        /*
         * Add the Australian boundary context for road and rail.
         */
        if (boundary.length > 0) {
            question += " in " + boundary.join(", ");
        }

        /*
         * Add the selected road, rail line, sea channel or transport mode.
         */
        if (link_name.length > 0) {
            question += " via " + link_name.join(", ");
        }

        /*
         * Add the selected month when a month filter is active.
         */
        if ("month_filter" in values_q) {
            question += " for the month of " + values_q["month_filter"];
        }

        question += "?";

        return question;
    }

    refreshMap() {
        if (this.hasUnconstrainedFilters && this.assistant.syncWithMap) {
            this.filter_assistant();
        }
        this.$emit("refresh_map");
    }

    // Triggered when a value is selected/removed in a filter, for example filterId = commodity, value = 126 (acid)
    onFiltersUpdated(filterId: string, value: any) {
        this.setFilterValue({ filter: filterId, value: value });
        this.setFiltersDirty();
        bus.$emit("filters_updated", filterId, value);
    }

    filterToggled(filterId: string, value: boolean, filter: any) {
        this.setFilterEnabled({ filter: filterId, value: value });

        if (!value && this.filterHasValue(filterId)) {
            this.onFiltersUpdated(filterId, []);
        }
    }
}
